import useHasExperiment from ':cloud/hooks/useHasExperiment';

export function useIsCOMSWriteEnabled() {
  return useHasExperiment('dec_2023_coms_write_endpoints', 'treatment');
}
